<template>
    <div class="footerbox">
        <div class="footer">
            <div class="footer_wd">
                <div class="item fl">
                    <div class="title">洗车机资讯</div>
                    <div class="item_c"> <a href="/a/zhishi/ruanjian/">公司新闻 </a> <a href="/a/zhishi/wangzhan/">行业资讯 </a> <a
                            href="/a/zhishi/app/">养车护车 </a> <a href="/a/zhishi/dianshang/">交规知识 </a> </div>
                </div>
                <div class="contact_f fl">
                    <div class="title">联系我们</div>
                    <div class="contact_eles"> 地址：广西梧州高新区星宇路七号 / 广州市海珠区暄悦东街23号保利中悦广场1001-1011 <br />
                        电话：400-800-8265 <br />
                        手机：18707745558 <br />
                        邮箱： </div>
                </div>
                <div class="footer_r fr">
                    <div class="link_btn">
                        <ul>
                            <li><a href="http://p.qiao.baidu.com/cps/chat?siteId=12982718&userId=24045328&siteToken=6fdb5d3f2fbc4febee60ab68862b9674"
                                    target="_blank" rel="nofollow" class="link_qq"></a></li>
                            <li class="link_weixin_li"><a href="javasctipt:void(0);" class="link_weixin" rel="nofollow"></a>
                                <div class="link_ewm"> <img src="/skin/images/weixin.jpg" width="129" height="129"> </div>
                            </li>
                            <li class="link_shouji_li"><a href="javasctipt:void(0);" class="link_shouji" rel="nofollow"></a>
                                <div class="link_ewm"> <img src="/skin/images/weixin.jpg" width="129" height="129"> </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer2">
            <div class="footer_w"> <img src="/skin/images/footer_jiant_03.jpg">
                <div class="copyright">Copyright &copy; 2002-2020 广西车便捷数字科技股份有限公司  版权所有   备案号：<a
                        href="http://beian.miit.gov.cn" target="_blank" rel="nofollow"> 桂ICP备16004681号|桂ICP备15003171号-1|桂公网安备-45040302000212号</a>  <a
                        href="/sitemap.xml" target="_blank"><!--XML地图--></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
        }
    },
}
</script>
